// filter-constants.js

export const FILTER_FACILITIES =
    "facilities";

export const FILTER_FACILITY_EXCLUDES =
    "facilityExcludes";

export const FILTER_FLOORS =
    "floors";

export const FILTER_FLOOR_EXCLUDES =
    "floorExcludes";

export const FILTER_FLOOR_ZONES =
    "floorZones";

export const FILTER_FLOOR_ZONE_EXCLUDES =
    "floorZoneExcludes";

export const FILTER_SPACES =
    "spaces";

export const FILTER_SPACE_EXCLUDES =
    "spaceExcludes";

export const FILTER_SPACE_TYPES =
    "spaceTypes";

export const FILTER_SPACE_TYPE_EXCLUDES =
    "spaceTypeExcludes";

export const FILTER_SPACE_TYPE_SUBS =
    "spaceTypeSubs";

export const FILTER_SPACE_TYPE_SUB_EXCLUDES =
    "spaceTypeSubExcludes";

export const FILTER_ORGANISATIONS =
    "organisations";

export const FILTER_ORGANISATION_EXCLUDES =
    "organisationExcludes";

export const FILTER_ORGANISATION_SUBS =
    "organisationSubs";

export const FILTER_ORGANISATION_SUB_EXCLUDES =
    "organisationSubExcludes";

export const FILTER_CLASSIFICATIONS =
    "classifications";

export const FILTER_CLASSIFICATION_EXCLUDES =
    "classificationExcludes";

export const FILTER_CLASSIFICATION_ITEMS =
    "classificationItems";

export const FILTER_CLASSIFICATION_ITEM_EXCLUDES =
    "classificationItemExcludes";

export const FILTER_UTILISATION_SURVEYS =
    "utilisationSurveys";

export const FILTER_UTILISATION_SURVEY_EXCLUDES =
    "utilisationSurveyExcludes";
	
	export const FILTER_TYPE_FACILITY =
	    "facilities";

	export const FILTER_TYPE_FLOOR =
	    "floors";

	export const FILTER_TYPE_SPACE_TYPE =
	    "spaceTypes";

	export const FILTER_TYPE_SPACE_TYPE_SUB =
	    "spaceTypeSubs";

	export const FILTER_TYPE_ORGANISATION =
	    "organisations";

	export const FILTER_TYPE_ORGANISATION_SUB =
	    "organisationSubs";

	export const FILTER_TYPE_SPACE =
	    "spaces";

	
	
	export const FILTER_URL_FACILITY =
	    "/resolutionsoftwareplatform/filtergetfacilities";

	export const FILTER_URL_FLOOR =
	    "/resolutionsoftwareplatform/filtergetfloors";

	export const FILTER_URL_FLOOR_ZONE =
	    "/resolutionsoftwareplatform/filtergetfloorzones";

	export const FILTER_URL_SPACE =
	    "/resolutionsoftwareplatform/filtergetspaces";

	export const FILTER_URL_SPACE_TYPE =
	    "/resolutionsoftwareplatform/filtergetspacetypes";

	export const FILTER_URL_SPACE_TYPE_SUB =
	    "/resolutionsoftwareplatform/filtergetspacetypessub";

	export const FILTER_URL_ORGANISATION =
	    "/resolutionsoftwareplatform/filtergetorganisations";

	export const FILTER_URL_ORGANISATION_SUB =
	    "/resolutionsoftwareplatform/filtergetorganisationssub";

	export const FILTER_URL_CLASSIFICATION =
	    "/resolutionsoftwareplatform/filtergetclassifications";

	export const FILTER_URL_CLASSIFICATION_ITEM =
	    "/resolutionsoftwareplatform/filtergetclassificationitems";

	export const FILTER_URL_UTILISATION_SURVEY =
	    "/resolutionsoftwareplatform/filtergetutilisationsurveys";
		
		
		// constants/filter-constants.js

	export const EMPTY_FILTER_BEAN =
	{
	    facilities: [],
	    facilityExcludes: [],

	    floors: [],
	    floorExcludes: [],

	    floorZones: [],
	    floorZoneExcludes: [],

	    spaces: [],
	    spaceExcludes: [],

	    spaceTypes: [],
	    spaceTypeExcludes: [],

	    spaceTypeSubs: [],
	    spaceTypeSubExcludes: [],

	    organisations: [],
	    organisationExcludes: [],

	    organisationSubs: [],
	    organisationSubExcludes: [],

	    classifications: [],
	    classificationExcludes: [],

	    classificationItems: [],
	    classificationItemExcludes: [],

	    showCoreDayOnly: 0,
	    showDesksMeetings: -100
	};
	
	export const EMPTY_QUERY_CONTEXT =
	{
	    utilisationSurveyId: 1
	};